var _rect, _path, _circle, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKancelariaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 28,
    height: 20,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14l12 9 12-9",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 12,
    r: 5,
    fill: "currentColor",
    opacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8v8M24 12h8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 33,
    fontFamily: "Inter, sans-serif",
    fontWeight: 800,
    fontSize: 22,
    fill: "currentColor",
    letterSpacing: -0.5
  }, "AI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 68,
    y: 33,
    fontFamily: "Noto Sans Georgian, sans-serif",
    fontWeight: 700,
    fontSize: 20,
    fill: "currentColor",
    letterSpacing: -0.3
  }, "\u10D9\u10D0\u10DC\u10EA\u10D4\u10DA\u10D0\u10E0\u10D8\u10D0")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKancelariaLogo);
export default __webpack_public_path__ + "static/media/kancelaria-logo.c2e13a711d8ee94ab116996618e36349.svg";
export { ForwardRef as ReactComponent };